import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import { ThemeProvider } from '@material-ui/core/styles';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import theme from "./theme";

//Mi server per riportare la vista della pagina al Top
import ScrollToTop from './components/ScrollToTop';

import App from './App';

//basename indica la subdirectory dove installare l'app
console.log(process.env.PUBLIC_URL);
const history = createBrowserHistory({basename: process.env.PUBLIC_URL});

ReactDOM.render(
  <Router history={history} basename={'/parole_ricerca'}>
    <ThemeProvider theme = {theme}>
      <ScrollToTop />
      <App />
    </ThemeProvider>
  </Router>,
  document.getElementById('root')
);
